export const resetSujetoObligadoAp = (setFieldsValue) => {
  setFieldsValue({ idSujetoObligadoAprobados: undefined });
};
export const resetSujetosObligadosFields = (setFieldsValue) => {
  setFieldsValue({ sujetoObligadoIdentificar: undefined });
  resetSujetoObligadoAp(setFieldsValue);
};

export const resetTipoAsociacion = (setFieldsValue) => {
  setFieldsValue({ idTipoAsociacion: undefined });
  resetSujetosObligadosFields(setFieldsValue);
};

export const resetProcesoEspecifico = (setFieldsValue) => {
  setFieldsValue({ idProcesoEspecifico: undefined });
  resetTipoAsociacion(setFieldsValue);
};

export const resetAmbitoProcesoEspecifico = (setFieldsValue) => {
  setFieldsValue({ ambito: undefined });
  resetProcesoEspecifico(setFieldsValue);
};
